import React, { Component } from 'react';
import { connect } from 'react-redux';
import { NavBar, DataTables, BreadCumb, TimeOut } from '../../components';
import { DISPATCH_ID, SERVICE_RESPONSE } from '../../libs/utils/Const';
import { ApiClient } from '../../libs/apiClient';
import config from '../../config';

let apiClient = ApiClient.getInstance();

const headersDataTable = [
    { title: "Clave", value: true },
    { title: "Tipo Figura", value: true },
    { title: "Nombre", value: true },
    { title: "RUT", value: true },
    { title: "No. Licencia", value: true },
    { title: "Codigo Postal", value: true },
    { title: "Pais", value: true },
];

class FiguraTransporteView extends Component {
    constructor(props) {
        super(props);

        this.state = {
            updateData: false,
            headers: headersDataTable,
            data: [],
            total: 0
        }
    }

    async componentDidMount(filter) {
        localStorage.setItem(config.localStorageNamed + 'toogleNavBarItem', "liFiguraTransporte");
        await this.callDocumentsListService(filter);
    }

    searchFiguraTransporte = async filter => {
        await this.callDocumentsListService(filter);

    };

    callDocumentsListService = async (filter = { priceValue: '---', groupCodeValue: '---', employeeValue: '---' }) => {
        const { enableSpinner } = this.props;
        enableSpinner(true);
        // console.log('con<ENTRE',);
        let figuraTransporteResponse = await apiClient.getFiguraTransporteList(filter);
        // console.log('con<figuraTransporteResponse', figuraTransporteResponse);

        if (figuraTransporteResponse.status === SERVICE_RESPONSE.SUCCESS) {
            this.setState({
                data: figuraTransporteResponse.data.manager,
                total: figuraTransporteResponse.data.totalRows
            });

        }
        enableSpinner(false);
    };

    render() {
        const { headers, data, total } = this.state;
        const itemsDashboard = JSON.parse(localStorage.getItem(config.localStorageNamed + 'itemsDashboard'));
        return (
            <div className="content">
                <NavBar props={this.props} itemsDashboard={itemsDashboard} />
                <TimeOut />
                <BreadCumb subitem1={'FIGURAS TRANSPORTE'} url1={'#'} />
                <div style={{ marginLeft: "4rem", marginBottom: "12rem" }}>
                    <h2 className="md-display-1">
                        <label id="liFiguraTransporte" className="text-muted">
                            &nbsp;FIGURAS TRANSPORTE
                        </label>
                    </h2>
                    <DataTables
                        headers={headers}
                        view={"figuresTransport"}
                        data={data}
                        search={this.searchFiguraTransporte}
                        totalRows={total} />
                </div>
            </div>
        );
    }
}

const mapStateToProps = store => {
    return { notificationReducer: store.NotificationReducer };
};

const mapDispatchToProps = dispatch => {
    return {
        enableSpinner: value => dispatch({ type: DISPATCH_ID.CONFIG_SET_SPINNER, value })
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(FiguraTransporteView);